import React, { useEffect, useState } from "react";
import backend from "../../../../../api";
import { useSelector } from "react-redux";
import { Card, CardActions, CardContent, CardHeader } from "@material-ui/core";
import TransactionInfoCard from "../../../../common/cards/TransactionInfoCard";
import { url_encode } from "../../../../../utils";
import useDebounce from "../AdWorkShop/hooks/useDebounce";
import ReactPaginate from "react-paginate";
import CustomDatePicker from "../../../../common/CustomDatePicker";
import GridLoader from "react-spinners/GridLoader";

const TransactionListing = ({ activeTab }) => {
  const { user } = useSelector((state) => state.auth);
  const [transactions, setTransactions] = useState({
    count: 0,
    totalPages: 1,
    data: [],
  });

  const [params, setParams] = useState({
    from: "",
    to: "",
    search: "",
    user: user?.user?._id,
    page: 1,
    limit: 3,
    order_pos: false,
  });

  const [isLoaidng, setIsLoading] = useState(false);

  const debouncedSearch = useDebounce(params?.search, 500);

  const handleParamsChange = (name, value) => {
    setParams((prevState) => ({ ...prevState, [name]: value }));
  };

  const handlePageChange = ({ selected }) => {
    handleParamsChange("page", selected + 1);
  };

  const handleDateChange = (date) => {
    handleParamsChange("from", date?.from);
    handleParamsChange("to", date?.to);
    handleParamsChange("page", 1);
  };

  const handleSearch = (e) => {
    handleParamsChange("search", e.target.value);
    handleParamsChange("page", 1);
  };

  const getTransactions = async (params) => {
    setIsLoading(true);
    try {
      if (user?.user?.role === "member") {
        delete params.order_pos;
      }
      const endPoints =
        activeTab === "e-money" ? "/eMoney-userwallet/wallet" : "/userwallet";
      const response = await backend.get(endPoints, {
        params: {
          ...params,
          populate: url_encode([
            {
              path: "user",
            },
            {
              path: "order",
              populate: [
                {
                  path: "items",
                  populate: [
                    {
                      path: "product",
                      populate: [
                        { path: "merchant_user", select: "-password" },
                      ],
                    },
                  ],
                },
              ],
            },
          ]),
        },
      });
      setTransactions({
        count: response?.data?.totalDocs,
        totalPages: response?.data?.totalPages,
        data: response?.data?.data,
      });
    } catch (error) {
      console.error("error: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTransactions(params);
  }, [params?.user, params?.page, params?.from, params?.to, debouncedSearch]);

  return (
    <Card>
      <CardHeader title="My Transactions" />
      <CardActions>
        <div className="row w-100">
          <div className="col-md-6 mb-3">
            <input
              type="text"
              className="form-control mb-0"
              placeholder="Search"
              onChange={handleSearch}
              value={params?.search}
            />
          </div>
          <div className="col-md-6">
            <CustomDatePicker
              onConfirm={handleDateChange}
              value={{ from: params?.from, to: params?.to }}
            />
          </div>
        </div>
      </CardActions>
      <CardContent>
        {isLoaidng ? (
          <div className=" d-flex justify-content-center w-100 py-5">
            <GridLoader color={"#000000"} loading={isLoaidng} size={40} />
          </div>
        ) : transactions.data?.length > 0 ? (
          <>
            {transactions.data?.map((el, index) => {
              return (
                <div key={index} className="mb-3">
                  <TransactionInfoCard item={el} />
                </div>
              );
            })}
            <div className="d-flex align-items-center justify-content-center mt-3">
              <ReactPaginate
                pageCount={transactions?.totalPages}
                onPageChange={handlePageChange}
                forcePage={params?.page - 1}
                previousLabel={"<<"}
                nextLabel={">>"}
                breakLabel={"..."}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
              />
            </div>
          </>
        ) : (
          <div className="d-flex justify-content-center align-items-center w-100 h-100">
            <h3>No Transactions Available</h3>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TransactionListing;
